export default function videoEmbedBlock() {
  const embeds = document.querySelectorAll('[data-js="video-embed"]');

  if (!embeds.length) return;

  embeds.forEach((embed) => {
    const poster = embed.querySelector('[data-js="video-poster"]');
    const player = embed.querySelector('[data-js="video-player"]');
    const playBtn = embed.querySelector('[data-js="video-play"]');

    if (!poster || !player || !playBtn) return;

    playBtn.addEventListener('click', () => {
      const source = playBtn.dataset.videoSource;
      const youtubeId = playBtn.dataset.youtubeId;
      const vimeoId = playBtn.dataset.vimeoId;
      const fileUrl = playBtn.dataset.videoFile;

      player.innerHTML = '';

      if (source === 'youtube' && youtubeId) {
        player.innerHTML = `
          <iframe
            src="https://www.youtube-nocookie.com/embed/${youtubeId}?autoplay=1&rel=0&playsinline=1&modestbranding=1"
            title="YouTube video"
            frameborder="0"
            allow="autoplay; encrypted-media; picture-in-picture"
            allowfullscreen
          ></iframe>
        `;
      } else if (source === 'vimeo' && vimeoId) {
        player.innerHTML = `
          <iframe
            src="https://player.vimeo.com/video/${vimeoId}?autoplay=1&title=0&byline=0&portrait=0"
            title="Vimeo video"
            frameborder="0"
            allow="autoplay; encrypted-media; picture-in-picture"
            allowfullscreen
          ></iframe>
        `;
      } else if (source === 'mp4' && fileUrl) {
        player.innerHTML = `
          <video controls autoplay playsinline>
            <source src="${fileUrl}" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        `;
      } else {
        return;
      }

      poster.hidden = true;
      player.hidden = false;
    });
  });
}
